import Text, { TextProps } from "./Text"

import "./Text.less"

export default function TextH4({ className, ...props }: TextProps) {
  return <Text className={`TextH4 ${className || ""}`} {...props} />
}
